import {
  HeadingText,
  BodyText,
  Checkbox,
  Button,
  Row,
  Col,
  Alert,
  TextInput,
  LoadingSpinner,
  Container,
} from '@paypalcorp/pp-react'
import { string, array, bool } from 'prop-types'
import { Message } from '@paypalcorp/worldready-react'
import { React, Fragment, memo, useState, useEffect } from 'react'
import { fptiCustomImpression, fptiCustomClick } from '../../../utils'
import serverData from '../../../utils/server-data'
import { DATA_DELETION_SUBMIT_URL } from '../../../constants/constants'
import { post } from '../../../utils/ajax.js'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
import asASlide from '../../common/as-a-slide'

const DeletionFeedback = memo((props) => {
  const deletionFpti = DATAPRIVACY_FPTI.DELETION
  const deletionFpti_CHECKBOX = DATAPRIVACY_FPTI.DELETION.CHECKBOX
  const [impressionDone, setImpressionDone] = useState(false)
  const [selectedOptions, setSelectedOptions] = useState(props.selectedOptions)
  const [comments, setComments] = useState(props.comments)
  const [showSpinner, setShowSpinner] = useState(props.showSpinner)
  const [showAlert, setShowAlert] = useState(props.showAlert)
  const [isValidRequest, setIsValidRequest] = useState(false)

  const {
    onModalNavigate,
    updateModalStore,
    modalParams: { storedFeedback = [], storedComment = '' } = {},
  } = props

  const validateMandatoryCheck = (checkedOptions) => {
    return checkedOptions.length ? true : false
  }

  async function handleSubmitClick(event) {
    event.preventDefault()
    fptiCustomClick(deletionFpti.SUBMIT_BTN)

    let isValid = validateMandatoryCheck(selectedOptions)
    if (!isValid) {
      setShowAlert(true)
    } else {
      setShowAlert(false)
      let reqparams = {
        _csrf: serverData._csrf,
        feedback: JSON.stringify(selectedOptions),
        comment: comments,
      }
      postDeletionRequest(reqparams)
    }
  }

  async function postDeletionRequest(reqparams) {
    setShowSpinner(true)

    let response = await post(DATA_DELETION_SUBMIT_URL, reqparams)
    if (response.success) {
      setShowAlert(false)
      setIsValidRequest(false)
      if (response && response.data && response.data.msg === 'success')
        onModalNavigate(3)
      else {
        location.href = response && response.data && response.data.redirect
      }
    } else {
      setShowSpinner(false)
      setShowAlert(true)
      setIsValidRequest(true)
    }
  }

  const onCommentChange = (event) => {
    const value = event.target.value
    setComments(value)
    updateModalStore({ storedComment: value })
  }
  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(deletionFpti.FEEDBACK_IMPRESSION)
    }
    let params = serverData.deletionReqParams || {}

    if (props.redirect === 'authweb') {
      postDeletionRequest(params)
    }
    let { feedback, comment } = params
    setSelectedOptions(feedback || storedFeedback || [])
    setComments(comment || storedComment || '')
  }, [])
  const onCheckboxClick = (event) => {
    const value = event.target.value

    let isChecked = event.target.checked
    if (isChecked && deletionFpti_CHECKBOX.link) {
      deletionFpti_CHECKBOX.link.length = 0
      deletionFpti_CHECKBOX.link.push(value)
      fptiCustomClick(deletionFpti_CHECKBOX)
    }

    let index = selectedOptions.indexOf(value)
    let selectedItemsDup = []
    Object.assign(selectedItemsDup, selectedOptions)
    setSelectedOptions([])

    if (index === -1) {
      selectedItemsDup.push(value)
    } else {
      selectedItemsDup.splice(index, 1)
    }
    setSelectedOptions(selectedItemsDup)
    updateModalStore({ storedFeedback: selectedItemsDup })
  }
  return (
    <Fragment>
      {showSpinner ? (
        <div>
          <div className="requestForm-spinner">
            <LoadingSpinner screenReaderText="loading" size="lg" theme="v2" />
          </div>
        </div>
      ) : (
        <Container form>
          {showAlert && (
            <Alert
              theme="v2"
              className="requestForm-row"
              type="error"
              closeButton={{
                onClick: () => {
                  setShowAlert(false)
                  setIsValidRequest(false)
                },
              }}
            >
              <Message
                id={
                  isValidRequest
                    ? 'dar.header.alert.fail'
                    : 'dar.section.submit.fail'
                }
              />
            </Alert>
          )}

          <HeadingText id="feedbackHeader" size="lg">
            <Message id="dataErasure.section.feedbackHeading" />
          </HeadingText>
          <BodyText className="dataPrivacy-row">
            <Message id="dataErasure.section.feedbackDesc" />
          </BodyText>
          <Row className="dataPrivacy-row">
            <Col>
              <Checkbox
                theme="v2"
                id="another_pp_account"
                name="option"
                value="I have another PayPal account"
                checked={
                  selectedOptions &&
                  selectedOptions.includes('I have another PayPal account')
                }
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackone" />}
              />
              <Checkbox
                theme="v2"
                name="option"
                id="only_pp_account"
                className="feedback-checkbox"
                value="This is my only PayPal account, but I don't use it"
                checked={
                  selectedOptions &&
                  selectedOptions.includes(
                    "This is my only PayPal account, but I don't use it",
                  )
                }
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackTwo" />}
              />

              <Checkbox
                theme="v2"
                name="option"
                id="concerned_data_privacy"
                className="feedback-checkbox"
                value="I'm concerned about data privacy"
                checked={
                  selectedOptions &&
                  selectedOptions.includes("I'm concerned about data privacy")
                }
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackThree" />}
              />

              <Checkbox
                theme="v2"
                name="option"
                id="too_many_mails"
                className="feedback-checkbox"
                value="I receive too many emails and notifications"
                checked={
                  selectedOptions &&
                  selectedOptions.includes(
                    'I receive too many emails and notifications',
                  )
                }
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackFour" />}
              />

              <Checkbox
                theme="v2"
                name="option"
                id="other_reasons"
                className="feedback-checkbox"
                value="Other reasons (please specify below)"
                checked={
                  selectedOptions &&
                  selectedOptions.includes(
                    'Other reasons (please specify below)',
                  )
                }
                onChange={onCheckboxClick}
                label={<Message id="dataErasure.section.feedbackFive" />}
              />
            </Col>
          </Row>
          <Row className="dataPrivacy-row">
            <Col>
              <TextInput
                theme="v2"
                name="comment"
                id="add_comments"
                value={comments}
                onChange={onCommentChange}
                label={<Message id="dataErasure.section.addCommentLabel" />}
                multiline
              />
            </Col>
          </Row>
          <Row className="dataPrivacy-btn-row">
            <Col sm={6} md={6}>
              <Button
                theme="v2"
                id="submitBtn"
                size="ld"
                onClick={handleSubmitClick}
                className="dataPrivacy-btn-fullwidth"
              >
                <Message id="dataErasure.section.submitRequest" />
              </Button>
            </Col>
          </Row>
        </Container>
      )}
    </Fragment>
  )
})

DeletionFeedback.propTypes = {
  selectedOptions: array,
  comments: string,
  showSpinner: bool,
  showAlert: bool,
}
DeletionFeedback.defaultProps = {
  selectedOptions: [],
  comments: '',
  showSpinner: false,
  showAlert: false,
}
DeletionFeedback.displayName = 'DeletionFeedback'
export default asASlide({ position: 2 })(DeletionFeedback)
